import apiClient from '../axiosInstance';

import { getShopButtonAction } from '../sagas/button/buttonSaga';
import { API_BASE_ADDRESS } from '../api';

// 店舗ボタンを取得します。
const shopButtonServices = (action: getShopButtonAction): any => {
  return {
    getShopButton: () => apiClient.get(`${API_BASE_ADDRESS}/mypage/shop/${action.shopId}/button/${action.buttonId}`),
  };
};

export default shopButtonServices;
